export default {
  meta: {
    title: '新开店报表',
    url: '/home/config' // 埋点用，记录所属模块
  },
};
